export const lengthUnit = (ms) => (ms === 'imperial' ? 'ft' : 'mm');
export const pressureUnit = (ms) => ms === 'imperial' ? 'PSF' : 'kN/m²';
export const weightUnit = (ms) => (ms === 'imperial' ? 'lbs' : 'kg');
/** Regular (straight) wall fields, excluding the nested `height` object (rendered separately). */
export const REGULAR_FIELDS = [
    { key: 'length', label: 'Wall Length', kind: 'length' },
    { key: 'thickness', label: 'Average Thickness', kind: 'length' },
    { key: 'segments', label: 'Number of Segments', kind: 'count' },
    { key: 'offsets', label: 'Offsets', kind: 'count' },
    { key: 'double_sided', label: 'Double Sided Segments', kind: 'count' },
    { key: 'single_sided', label: 'Single Sided Segments', kind: 'count' },
    { key: 'cross_junctions', label: 'Cross Junctions', kind: 'count' },
    { key: 't_junctions', label: 'T Junctions', kind: 'count' },
    { key: 'stop_ends', label: 'Stopends', kind: 'count' },
    { key: 'perpendicular_angles', label: 'Perpendicular Corners', kind: 'count' },
    { key: 'non_perpendicular_angles', label: 'Non-Perpendicular Corners', kind: 'count' },
    { key: 'shafts', label: 'Shafts (Rooms)', kind: 'count' }
];
export const ARC_FIELDS = [
    { key: 'radius', label: 'Radius', kind: 'length' },
    { key: 'length', label: 'Arc Length', kind: 'length' },
    { key: 'height', label: 'Height', kind: 'length' },
    { key: 'thickness', label: 'Thickness', kind: 'length' },
    { key: 'double_sided', label: 'Double Sided', kind: 'boolean' }
];
export const COLUMN_FIELDS = [
    { key: 'x_width', label: 'X Width', kind: 'length' },
    { key: 'y_width', label: 'Y Width', kind: 'length' },
    { key: 'height', label: 'Height', kind: 'length' }
];
